export default __webpack_public_path__ + "static/stacked-area-81629d8954842bf4bc9ce21987086827.png";